/**
 * Empty cart — personalize "Recommended for you" from browse taste (shape + color).
 */
(function () {
  var SECTION_ID = 'ciw-cart-taste-rec';
  var TARGET_COUNT = 20;
  var BUCKET_MAX = 10;
  var MAX_ANCHORS = 5;

  function colorFamily(color) {
    if (window.CIW_BROWSE_TASTE && typeof window.CIW_BROWSE_TASTE.colorFamily === 'function') {
      return window.CIW_BROWSE_TASTE.colorFamily(color);
    }
    var c = String(color || '').toLowerCase();
    if (!c) return 'other';
    if (/black|onyx|noir|ebony/.test(c)) return 'black';
    if (/tortoise|havana|horn|leopard|spot|demi/.test(c)) return 'tortoise';
    if (/gold|champagne|copper|bronze|rose gold/.test(c)) return 'gold';
    if (/silver|gunmetal|steel|chrome|nickel|metallic|titanium/.test(c)) return 'silver';
    if (/clear|crystal|transparent|ice|polished transparent/.test(c)) return 'clear';
    if (/blue|navy|azure|sapphire|cobalt/.test(c)) return 'blue';
    if (/brown|coffee|caramel|wood|amber|mocha|honey|tan/.test(c)) return 'brown';
    if (/green|olive|emerald|mint/.test(c)) return 'green';
    if (/pink|rose|mauve|coral|fuchsia/.test(c)) return 'pink';
    if (/red|burgundy|wine|maroon|cranberry|cherry/.test(c)) return 'red';
    if (/grey|gray|smoke|charcoal|slate|graphite/.test(c)) return 'grey';
    if (/purple|violet|plum|lilac|lavender/.test(c)) return 'purple';
    if (/white|pearl|ivory|cream|beige|nude|sand|bone/.test(c)) return 'neutral';
    return 'other';
  }

  function readTaste() {
    if (window.CIW_BROWSE_TASTE && typeof window.CIW_BROWSE_TASTE.read === 'function') {
      return window.CIW_BROWSE_TASTE.read();
    }
    try {
      var list = JSON.parse(localStorage.getItem('ciwBrowseTaste') || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function pickAnchors(taste) {
    var anchors = [];
    var seenHandles = {};
    var seenShapes = {};

    taste
      .slice()
      .sort(function (a, b) {
        return (b.viewedAt || 0) - (a.viewedAt || 0);
      })
      .forEach(function (entry) {
        if (!entry || !entry.handle || seenHandles[entry.handle]) return;
        if (!entry.shape) return;
        if (seenShapes[entry.shape] && anchors.length >= 2) return;
        seenHandles[entry.handle] = true;
        seenShapes[entry.shape] = true;
        anchors.push(entry);
      });

    if (anchors.length < MAX_ANCHORS) {
      taste.forEach(function (entry) {
        if (!entry || !entry.handle || seenHandles[entry.handle]) return;
        if (!entry.shape) return;
        seenHandles[entry.handle] = true;
        anchors.push(entry);
      });
    }

    return anchors.slice(0, MAX_ANCHORS);
  }

  function buildColorWeights(taste) {
    var weights = {};
    taste.forEach(function (entry) {
      if (!entry) return;
      var family = entry.colorFamily || colorFamily(entry.color);
      if (!family || family === 'other') return;
      weights[family] = (weights[family] || 0) + 1;
    });
    return weights;
  }

  function buildShapeWeights(taste) {
    var weights = {};
    taste.forEach(function (entry) {
      if (!entry || !entry.shape) return;
      weights[entry.shape] = (weights[entry.shape] || 0) + 1;
    });
    return weights;
  }

  function fetchAnchorCards(handle) {
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID;
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('taste rec fetch failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root =
          doc.querySelector('[data-ciw-cart-taste-rec]') ||
          doc.querySelector('.ciw-cart-taste-rec-section');
        if (!root) return [];

        return Array.prototype.slice.call(root.querySelectorAll('[data-ciw-rec-handle]'));
      })
      .catch(function () {
        return [];
      });
  }

  function unwrapCard(wrapper) {
    var card = wrapper.querySelector('.ciw-pdp-rec__card');
    if (!card) return null;

    card.dataset.ciwRecHandle = wrapper.getAttribute('data-ciw-rec-handle') || '';
    card.dataset.ciwRecDesigner = wrapper.getAttribute('data-ciw-rec-designer') || 'false';
    card.dataset.ciwRecShape = wrapper.getAttribute('data-ciw-rec-shape') || '';
    card.dataset.ciwRecColor = wrapper.getAttribute('data-ciw-rec-color') || '';
    return card;
  }

  function scoreCard(card, colorWeights, shapeWeights, viewedHandles, tasteIndex) {
    var handle = card.dataset.ciwRecHandle;
    if (!handle || viewedHandles[handle]) return -1;

    var shape = card.dataset.ciwRecShape || '';
    var colorFamilyKey = colorFamily(card.dataset.ciwRecColor || '');
    var score = 0;

    score += (shapeWeights[shape] || 0) * 40;
    score += (colorWeights[colorFamilyKey] || 0) * 25;

    if (tasteIndex[handle] != null) {
      score += Math.max(0, 20 - tasteIndex[handle]);
    }

    return score;
  }

  function pickBalancedList(scoredCards) {
    var designer = [];
    var house = [];
    var picked = [];
    var pickedHandles = {};

    scoredCards.forEach(function (item) {
      var handle = item.card.dataset.ciwRecHandle;
      if (!handle || pickedHandles[handle]) return;
      if (item.card.dataset.ciwRecDesigner === 'true') designer.push(item);
      else house.push(item);
    });

    var d = 0;
    var h = 0;
    while (picked.length < TARGET_COUNT && (d < designer.length || h < house.length)) {
      if (d < designer.length && picked.filter(function (x) { return x.card.dataset.ciwRecDesigner === 'true'; }).length < BUCKET_MAX) {
        var dItem = designer[d++];
        if (!pickedHandles[dItem.card.dataset.ciwRecHandle]) {
          picked.push(dItem);
          pickedHandles[dItem.card.dataset.ciwRecHandle] = true;
        }
      }

      if (picked.length >= TARGET_COUNT) break;

      if (h < house.length && picked.filter(function (x) { return x.card.dataset.ciwRecDesigner !== 'true'; }).length < BUCKET_MAX) {
        var hItem = house[h++];
        if (!pickedHandles[hItem.card.dataset.ciwRecHandle]) {
          picked.push(hItem);
          pickedHandles[hItem.card.dataset.ciwRecHandle] = true;
        }
      }
    }

    if (picked.length < TARGET_COUNT) {
      scoredCards.forEach(function (item) {
        if (picked.length >= TARGET_COUNT) return;
        var handle = item.card.dataset.ciwRecHandle;
        if (!handle || pickedHandles[handle]) return;
        picked.push(item);
        pickedHandles[handle] = true;
      });
    }

    return picked.slice(0, TARGET_COUNT);
  }

  function fitRecTitles(section) {
    if (!section) return;
    section.querySelectorAll('.ciw-pdp-rec__title').forEach(function (el) {
      el.classList.remove('ciw-pdp-rec__title--clamped');
      el.style.fontSize = '';
    });
    document.dispatchEvent(new CustomEvent('ciw:cart-rec-updated', { detail: { section: section } }));
  }

  function init() {
    var section = document.querySelector('[data-ciw-cart-rec]');
    var track = document.querySelector('[data-ciw-cart-rec-track]');
    if (!section || !track) return;

    var taste = readTaste().filter(function (entry) {
      return entry && entry.handle && entry.shape;
    });
    if (!taste.length) return;

    var anchors = pickAnchors(taste);
    if (!anchors.length) return;

    section.setAttribute('data-ciw-cart-rec-loading', 'true');

    Promise.all(anchors.map(function (anchor) {
      return fetchAnchorCards(anchor.handle);
    }))
      .then(function (groups) {
        var wrappers = [];
        groups.forEach(function (group) {
          wrappers = wrappers.concat(group);
        });

        var cards = wrappers
          .map(unwrapCard)
          .filter(function (card) {
            return !!card;
          });

        if (!cards.length) return;

        var colorWeights = buildColorWeights(taste);
        var shapeWeights = buildShapeWeights(taste);
        var viewedHandles = {};
        var tasteIndex = {};

        taste.forEach(function (entry, index) {
          if (entry && entry.handle) {
            viewedHandles[entry.handle] = true;
            if (tasteIndex[entry.handle] == null) tasteIndex[entry.handle] = index;
          }
        });

        var scored = cards
          .map(function (card) {
            return {
              card: card,
              score: scoreCard(card, colorWeights, shapeWeights, viewedHandles, tasteIndex)
            };
          })
          .filter(function (item) {
            return item.score >= 0;
          })
          .sort(function (a, b) {
            return b.score - a.score;
          });

        if (!scored.length) return;

        var finalList = pickBalancedList(scored);
        if (!finalList.length) return;

        track.innerHTML = '';
        finalList.forEach(function (item) {
          track.appendChild(item.card);
        });

        section.dataset.ciwCartRecPersonalized = 'true';
        section.removeAttribute('data-ciw-cart-rec-loading');
        fitRecTitles(section);
      })
      .catch(function () {
        section.removeAttribute('data-ciw-cart-rec-loading');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
